import { jwtDecode } from 'jwt-decode';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

// material-ui
import {
  Box,
  Button,
  Checkbox,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';

// third party

// project imports
import AnimateButton from 'ui-component/extended/AnimateButton';

// assets
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';

import getAxiosInstance from 'api';
import NotificationSnackBar from 'common/NotificationSnackBar';
import toast from 'react-hot-toast';

// ============================|| FIREBASE - LOGIN ||============================ //

const AuthLogin = ({ loginProp, ...others }) => {
  const theme = useTheme();

  const navigation = useNavigate();
  const [credentials, setCredentials] = useState({
    email: '',
    emailError: '',
    password: '',
    passwordError: '',
  });
  const [checked, setChecked] = useState(true);
  const [alert, setAlert] = useState({
    alertMessage: '',
    isOpen: '',
    status: '',
  });
  const [showPassword, setShowPassword] = React.useState(false);
  const handleClickShowPassword = () => {
    setShowPassword(!showPassword);
  };

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };
  const handleClose = () => {
    setAlert({
      ...alert,
      isOpen: false,
    });
  };
  const handleChange = (e) => {
    let newState = { ...credentials };
    const { name, value } = e.target;
    if (value) {
      newState[name + 'Error'] = null;
    }
    newState[name] = value;
    setCredentials(newState);
  };
  const handleSubmitClick = (event) => {
    event.preventDefault();
    const newState = { ...credentials };
    if (!credentials.email) {
      newState.emailError = 'Email is required';
    } else {
      newState.emailError = '';
    }
    if (!credentials.password) {
      newState.passwordError = 'Password is required';
    } else {
      newState.passwordError = '';
    }
    if (!credentials.email || !credentials.password) {
      setCredentials(newState);
    } else {
      try {
        getAxiosInstance(
          'businessPartner/apiUsers/login',
          'post',
          {
            email: credentials.email,
            password: credentials.password,
          },
          {
            'journey-type': 'Login',
          }
        )
          .then((res) => {
            if (res?.data?.codes === 200) {
              let decodeToken = jwtDecode(res?.data?.data?.accessToken);
              const userData = {
                accessToken: res?.data?.data?.accessToken,
                refreshToken: res?.data?.data?.refreshToken,
                ...decodeToken,
              };
              localStorage.setItem('userData', JSON.stringify(userData));
              localStorage.setItem('reviewStatus', res.data.data.reviewStatus);
              toast.success('login successfully.');
              if (
                res.data.data.reviewStatus === 'KYC_PENDING' ||
                res.data.data.reviewStatus === 'PENDING' ||
                res.data.data.reviewStatus === 'KYC_REJECTED'
              ) {
                navigation('/KYC');
              } else {
                navigation('/dashboard');
              }
            } else {
              toast.error(res?.message || 'An error occurred');
            }
          })
          .catch((err) => {
            toast.error(err?.message || "can't connect to backend");
          });
      } catch (err) {
        setAlert({
          alertMessage: "can't connect to backend",
          isOpen: true,
          status: theme.palette.success.light,
        });
      }
    }
  };
  return (
    <>
      <Grid
        container
        component={'form'}
        spacing={3}
        onSubmit={handleSubmitClick}
      >
        <Grid item xs={12}>
          <InputLabel>Email </InputLabel>
          <TextField
            type="email"
            name="email"
            placeholder="name@workmail.com"
            fullWidth
            hiddenLabel
            value={credentials?.email}
            onChange={handleChange}
            error={credentials.emailError}
            helperText={credentials.emailError}
          />
        </Grid>

        <Grid item xs={12}>
          <InputLabel>Password</InputLabel>
          <OutlinedInput
            type={showPassword ? 'text' : 'password'}
            name="password"
            placeholder="password"
            fullWidth
            hiddenLabel
            onChange={handleChange}
            error={credentials.passwordError}
            helperText={credentials.passwordError}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={handleMouseDownPassword}
                  edge="end"
                  size="large"
                >
                  {showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              </InputAdornment>
            }
            inputProps={{}}
          />
        </Grid>

        <Grid item xs={12} sx={{ paddingTop: '12px !important' }}>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
            spacing={1}
          >
            <FormControlLabel
              control={
                <Checkbox
                  checked={checked}
                  onChange={(event) => setChecked(event.target.checked)}
                  name="checked"
                  color="secondary"
                />
              }
              label="Remember me"
            />
            <Typography
              variant="h4"
              component={Link}
              to={'/forgot'}
              color="secondary"
              sx={{ textDecoration: 'none' }}
            >
              Forgot Password?
            </Typography>
          </Stack>
        </Grid>

        <Grid item xs={12}>
          <Box>
            <AnimateButton>
              <Button
                disableElevation
                fullWidth
                size="large"
                type="submit"
                variant="contained"
                color="secondary"
              >
                Sign in
              </Button>
            </AnimateButton>
          </Box>
        </Grid>
      </Grid>

      <Stack
        direction={'row'}
        alignItems={'center'}
        justifyContent={'center'}
        mt={5}
        gap={0.5}
      >
        <Typography variant="h4">Don’t have an account?</Typography>
        <Typography
          variant="h4"
          component={Link}
          to="/register"
          color={'secondary'}
        >
          Sign up
        </Typography>
      </Stack>

      <NotificationSnackBar alert={alert} handleClose={handleClose} />
    </>
  );
};

AuthLogin.propTypes = {
  loginProp: PropTypes.number,
};

export default AuthLogin;
